let styles = {
    container: {
        background: 'white',
        padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        textAlign:'center',
        fontSize:'16px'
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/VenueInfo/style.js